import { Controller } from "@hotwired/stimulus"
import { applyEnter } from "./utils/motion"

// Right-click context menu. Trigger is anything inside this controller's element
// with data-context-menu-target="trigger". Menu shows at cursor position.
//
// Cleanup completo no disconnect — Turbo navigations não vazam listeners.
//
// Motion: o menu aparece com fade+slide (animate-overlay-in). O fechamento é
// imediato (sem animação de saída) porque o menu reposiciona a cada abertura
// e fechar rápido evita "fantasmas" na posição antiga do cursor.
export default class extends Controller {
  static targets = ["trigger", "menu"]

  connect() {
    this.boundOutside     = (e) => !this.menuTarget.contains(e.target) && this.close()
    this.boundEsc         = (e) => e.key === "Escape" && this.close()
    this.boundContextMenu = this.open.bind(this)
    this.triggerTarget.addEventListener("contextmenu", this.boundContextMenu)
    document.addEventListener("click", this.boundOutside)
    document.addEventListener("keydown", this.boundEsc)
  }

  disconnect() {
    this.triggerTarget.removeEventListener("contextmenu", this.boundContextMenu)
    document.removeEventListener("click", this.boundOutside)
    document.removeEventListener("keydown", this.boundEsc)
  }

  open(e) {
    e.preventDefault()
    const rect = this.element.getBoundingClientRect()
    this.menuTarget.style.left = (e.clientX - rect.left) + "px"
    this.menuTarget.style.top  = (e.clientY - rect.top)  + "px"
    this.menuTarget.classList.remove("hidden")
    applyEnter(this.menuTarget, "animate-overlay-in")
  }

  close() { this.menuTarget.classList.add("hidden") }
}
